export default {
  prefixClz: {
    default: '',
  },
  title: {
    type: String,
    default: '',
  },
  content: {
    type: String,
    default: '',
  },
  hideContent: {
    type: Boolean,
    default: false,
  },
  textAlign: {
    type: String,
    default: 'center',
  },
  animation: {
    type: Boolean,
    default: false,
  },
  lockBgScroll: {
    type: Boolean,
    default: false,
  },
  visible: {
    type: Boolean,
    default: false,
  },
  showClose: {
    type: Boolean,
    default: false,
  },
  maskClosable: {
    type: Boolean,
    default: true,
  },
  noOkBtn: {
    type: Boolean,
    default: false,
  },
  noCancelBtn: {
    type: Boolean,
    default: false,
  },
  okBtnTxt: {
    type: String,
    default: '确认',
  },
  cancelBtnTxt: {
    type: String,
    default: '取消',
  },
  okBtnDisabled: {
    type: Boolean,
    default: false,
  },
  closeOnCancel: {
    type: Boolean,
    default: true,
  },
};
